import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../context/themeContext";
import { useSelector } from "react-redux";
import axios from "axios";
import { node_server } from "../../../../../../constants";

const SkillStatus = ({ skill }) => {
  const { theme, darkMode } = useTheme();
  const [skillsReports, setSkillsReports] = useState([]);
  const user = useSelector((state) => state.user.value);

  const handleReportClick = async () => {
    if (skillsReports.length === 0) {
      const { error } = await axios.post(
        `${node_server}/api/skills/reports`,
        {
          skillId: skill.id,
        },
        { withCredentials: true },
      );

      if (error) console.log(error);
      if (!error)
        setSkillsReports([{ skill_id: skill.id, reporter_id: user?.id }]);
    }
  };

  useEffect(() => {
    const fetchReports = async () => {
      const { data, error } = await axios.post(
        `${node_server}/api/skills/reports`,
        {
          skillId: skill.id,
        },
        { withCredentials: true },
      );

      if (error) console.log(error);
      if (data) setSkillsReports(data);
    };

    if (user?.id && skill) fetchReports();
  }, [skill, user]);

  if (!skill) return <div></div>;

  return (
    <Box
      className={styles.skillsCommunityStatus}
      sx={{
        background: theme.palette.lightgrey.lightgrey00,
      }}
    >
      <Box className={styles.report}>
        <Button
          style={{
            backgroundColor: darkMode
              ? "#3D3D3D"
              : theme.palette.lightgrey.lightgrey600,
            padding: "4px 12px",
          }}
          onClick={handleReportClick}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: "12px",
              color: theme.palette.darkgrey.darkgrey500,
            }}
          >
            {skillsReports.length > 0 ? "Reported" : "Report"}
          </Typography>
        </Button>
      </Box>
      <Box className={styles.skillsItem}>
        <Typography
          variant="body1"
          className={styles.heading}
          sx={{
            color: theme.palette.darkgrey.darkgrey600,
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          Category
        </Typography>
        <Box className={styles.tags}>
          <Chip label={skill.category} />
        </Box>
      </Box>
      <Box className={styles.skillsItem}>
        <Typography
          variant="body1"
          className={styles.heading}
          sx={{
            color: theme.palette.darkgrey.darkgrey600,
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          Skill
        </Typography>
        <Box className={styles.tags}>
          <Chip label={skill.name} />
        </Box>
      </Box>
      <Box className={styles.skillsItem}>
        <Typography
          variant="body1"
          className={styles.heading}
          sx={{
            color: theme.palette.darkgrey.darkgrey600,
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          Specialty
        </Typography>
        <Box className={styles.tags}>
          <Chip label={skill.speciality} />
        </Box>
      </Box>
    </Box>
  );
};

export default SkillStatus;
